import axios from "axios";
import React, { useEffect, useState } from "react";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function EditClassModal({
  cancelModal,
  selectedClass,
  fetchData,
}) {
  // styled
  const [name, setName] = useState("");
  const [nameErr, setNameErr] = useState("");
  const [description, setDescription] = useState("");
  const [descriptionErr, setDescriptionErr] = useState("");
  const [day, setDay] = useState("");
  const [timeIn, setTimeIn] = useState("");
  const [timeInErr, setTimeInErr] = useState("");
  const [timeOut, setTimeOut] = useState("");
  const [price, setPrice] = useState(null);
  const [priceErr, setPriceErr] = useState(null);
  // const [tokenErr, setTokenErr] = useState("");
  const [complete, setComplete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [timeOutErr, setTimeOutErr] = useState("");
  const [bookingCapacity, setBookingCapacity] = useState(0);

  const handlePriceChange = (e) => {
    const value = e.target.value ? parseFloat(e.target.value) : null;
    setPrice(value);
  };

  const { user } = useAuthContext();

  const nameRegex = /^[a-zA-Z0-9 ]+$/;

  function convertIntToTimeInputFormat(timeInt) {
    // Convert the integer to a string and pad with leading zeros if necessary
    let timeString = timeInt.toString().padStart(4, "0");

    // Ensure the input is a 4-digit string
    if (timeString.length !== 4 || isNaN(timeString)) {
      throw new Error("Invalid time format");
    }

    // Extract the hours and minutes from the string
    let hours = timeString.substring(0, 2);
    let minutes = timeString.substring(2, 4);

    // Format the time in HH:MM format
    return `${hours}:${minutes}`;
  }

  const getClass = async () => {
    setIsLoading(true);
    try {
      const classResponse = await axios.get(
        `${ApiConnectionString}/api/PendingEvent/${selectedClass.id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
  
      if (classResponse.status === 200) {
        setName(classResponse.data.name);
        setDescription(classResponse.data.description);
        setDay(classResponse.data.day);
        setTimeIn(convertIntToTimeInputFormat(classResponse.data.timeIn));
        setTimeOut(convertIntToTimeInputFormat(classResponse.data.timeOut));
        setPrice(classResponse.data.price / 100);
        setBookingCapacity(classResponse.data.bookingCapacity);
      }
    } catch (error) {
      console.error('Error fetching class:', error);
      // Optionally handle the error (e.g., display a message to the user)
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getClass();
  }, [user]);

  const convertTimeToInt = (time) => {
    return parseInt(time.replace(":", ""), 10);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.preventDefault();
    setNameErr("");
    setDescriptionErr("");
    setTimeInErr("");
    setPriceErr("")
    // setTokenErr("");
    let error = false;

    //Price Validation
    if (price > 50) {
      error = true;
      setPriceErr("The price must not exceed £50");
  } else if (price > 0 && price < 1) {
      error = true;
      setPriceErr("The price must be at least £1");
  }

    //Name Validations
    if (name.length > 60) {
      error = true;
      setNameErr("Name is too long");
    }
    if (!nameRegex.test(name)) {
      error = true;
      setNameErr("The Name can only include letters, spaces");
    }
    //Description Validations
    if (name.description > 3000) {
      error = true;
      setDescriptionErr("Name is too long");
    }
    //TimeIn Validation
    if (timeIn > timeOut) {
      error = true;
      setTimeInErr("Time in must not be greater than the time out");
    }

    //Token error
    // if (token > 1000) {
    //   error = true;
    //   setTokenErr("Classes are limited to 1000 tokens.");
    // }
    if (!error) {
      try {
        setIsLoading(true);

        const updatePendingEvent = {
          id: selectedClass.id,
          pendingClubId: selectedClass.pendingClubId,
          name,
          description,
          day,
          timeIn: convertTimeToInt(timeIn),
          timeOut: convertTimeToInt(timeOut),
          price: price * 100,
          bookingCapacity,
        };

        const createResponse = await axios.put(
          `${ApiConnectionString}/api/pendingEvent`,
          updatePendingEvent,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          }
        );

        if (createResponse.status == 200) {
        
          setComplete(true);
        }
      } catch (error) {
        console.error("Error creating pending event:", error);
        // Handle the error (e.g., display an error message to the user)
      } finally {
        setIsLoading(false); // Ensure that loading is stopped regardless of success or failure
      }
    }
  };
  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          {isLoading && <LoadingSpinner />}

          <div className="send-modal-footer"></div>
        </div>
      </div>
    );
  } else {
    if (complete) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Class Updated</p>
            </div>
            <button
              type="button"
              className="close-button"
              onClick={() => {  fetchData();cancelModal()}}
              aria-label="Close"
            >
              &times;
            </button>
            <p>The class has been updated successfully.</p>
            <div className="send-modal-footer">
              <button
                onClick={() => {  fetchData();cancelModal()}}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Edit Class</p>
            </div>
            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>

            <div>
              <form>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p className="red-text fw-bold mx-2">Class Name</p>
                      </td>
                      <td>
                        <input
                          type="text"
                          id="name"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          required
                        />
                        {nameErr && <p className="text-danger">{nameErr}</p>}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p className="red-text fw-bold mx-2">Description</p>
                      </td>
                      <td>
                        <textarea
                          id="description"
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                          required
                        />
                        {descriptionErr && (
                          <p className="text-danger">{descriptionErr}</p>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p className="red-text fw-bold mx-2">Time In</p>
                      </td>
                      <td>
                        <input
                          type="time"
                          id="timeIn"
                          value={timeIn}
                          onChange={(e) => setTimeIn(e.target.value)}
                          required
                        />
                        {timeInErr && (
                          <p className="text-danger">{timeInErr}</p>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p className="red-text fw-bold mx-2">Time Out</p>
                      </td>
                      <td>
                        <input
                          type="time"
                          id="timeOut"
                          value={timeOut}
                          onChange={(e) => setTimeOut(e.target.value)}
                          required
                        />
                        {timeOutErr && (
                          <p className="text-danger">{timeOutErr}</p>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="red-text fw-bold">
                        <label htmlFor="price">Class Capacity: </label>
                      </td>
                      <td>
                        <input
                          type="number"
                          id="classLimit"
                          name="classLimit"
                          pattern="^\d*$"
                          inputMode="numeric"
                          value={bookingCapacity}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Optionally validate the value or ignore invalid input
                            if (/^\d*$/.test(value)) {
                              setBookingCapacity(value);
                            }
                          }}
                        />
                        <p className="text-muted">
                          How many people can attend this at one time? If there
                          is no limit, leave it as zero.
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p className="red-text fw-bold mx-2">Price (£)</p>
                      </td>
                      <td>
                        <input
                          type="number"
                          id="price"
                          step="0.01"
                          value={price}
                          onChange={handlePriceChange}
                          placeholder="Enter price"
                        />
                      </td>
                    </tr>

                    {priceErr && <p className="text-danger">{priceErr}</p>}
                    <tr>
                      <td>
                        <p className="red-text fw-bold mx-2">Day</p>
                      </td>
                      <td>
                        <select
                          id="day"
                          value={day}
                          onChange={(e) => setDay(e.target.value)}
                          required
                        >
                          <option value="Monday">Monday</option>
                          <option value="Tuesday">Tuesday</option>
                          <option value="Wednesday">Wednesday</option>
                          <option value="Thursday">Thursday</option>
                          <option value="Friday">Friday</option>
                          <option value="Saturday">Saturday</option>
                          <option value="Sunday">Sunday</option>
                        </select>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <button
                  onClick={handleSubmit}
                  className="saveChanges-button mx-3"
                >
                  Update
                </button>
              </form>
            </div>
            <div className="send-modal-footer">
              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
}
